module.exports = __webpack_public_path__ + "media/images/flags/1x1/mwi-315852372388e36c72cd12dfd0aa75e6.svg";